










  import { defineComponent, computed, onMounted, onUnmounted } from 'vue'
  import { NavigationGuardNext, Route } from 'vue-router/types/router'
  import useCurrentInstance from '~/utils/useCurrentInstance'
  import { createIndexCmsComponents } from '~/utils/cmsComponents'

  export default defineComponent({
    name: 'Index',
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
    },

    beforeRouteEnter(_to: Route, _from: Route, next: NavigationGuardNext) {
      return next((vm: any) => {
        vm.$store.dispatch('products/clearSearchAndListing')
      })
    },
    middleware: ['isAuthenticatedOrPlatformOpened'],

    setup() {
      const vm = useCurrentInstance()

      const mainComponentClass = 'one-index-page'

      const configuration = computed(() => vm.$store.getters['cms/configuration'])
      const getClient = computed(() => vm.$store.getters['account/getClient'])

      const content = computed(() => configuration.value?.content)
      const loggedUser = computed(() => getClient.value ?? null)

      const availableComponents = createIndexCmsComponents()

      onMounted(() => {
        vm.$plugins.onMounted(mainComponentClass, vm)
      })

      onUnmounted(() => {
        vm.$store.commit('layout/TOGGLE_BACKDROP', false)
        vm.$plugins.onUnmounted(mainComponentClass)
      })

      return {
        mainComponentClass,
        availableComponents,
        content,
        configuration,
        loggedUser,
      }
    },

    fetch({ store }: any) {
      return store.commit('layout/TOGGLE_BREADCRUMBS', false)
    },

    head() {
      const vm = this as any

      return {
        script: [{
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            publisher: {
              name: vm.configuration?.tenantKey,
            },
            mainEntity: {
              '@type': 'Person',
              email: vm.loggedUser?.invoiceEmail,
              name: vm.loggedUser?.name,
              telephone: vm.loggedUser?.phone,
            },
          },
        }],
      }
    },
  })
